import { render } from "./Vosiki.vue?vue&type=template&id=953dbda8"
import script from "./Vosiki.vue?vue&type=script&lang=js"
export * from "./Vosiki.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__